import { all, takeLatest } from 'redux-saga/effects';

import { requestAndSet } from 'utils/helpers';

import { Location } from '../../types/locationTypes';
import { usersActions } from '../slices/usersSlice';

function* fetchSelectedUserLocationsSaga(
  action: ReturnType<typeof usersActions.fetchSelectedUserLocations>,
): Generator {
  yield requestAndSet(
    'getUserLocations',
    [action.payload.orgId, action.payload.userId],
    {
      createSetterAction: (res: unknown) =>
        usersActions.setSelectedUserLocations(
          ((res as { data?: Location[] }).data || []) as Location[],
        ),
    },
  );
}

export default function* usersSaga(): Generator {
  yield all([
    takeLatest(
      usersActions.fetchSelectedUserLocations.type,
      fetchSelectedUserLocationsSaga,
    ),
  ]);
}
